<template lang="pug">
  div(id="app")
    .nav-bar
      .nav-content
        .log
          img(src="../src/assets/images/logo1.png")
        .tab
          .index(@click="fnClickIndex" :class="$route.path === '/' ? 'select' : 'no-select'") 首页
          .download(@click="fnClickDownload" :class="$route.path === '/download' ? 'select' : 'no-select'") APP下载
    router-view
    .footer
      .footer-content
        p(style="") 开发者：北京乐学创想教育科技有限公司
        p(style="margin-top:6px") 电 话：400-155-6576
        .line
        p Copyright ©2014-2019 北京乐学创想教育科技有限公司 All Rights Reserved
        p(style="margin-top:6px") 京ICP备15003527号-1
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  mounted () {},
  created () {},
  methods: {
    fnClickIndex () {
      this.$router.replace({
        path: '/'
      })
    },
    fnClickDownload () {
      this.$router.replace({
        path: '/download'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.nav-bar{
  width: 100%;
  height: 60px;
  background-color: #fff;
}
.nav-content{
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.log{
  width: 200px;
  height: 60px;
  display: flex;
  align-items: center
}
.log > img{
  width: 100px;
  align-items: center;
  height: 40px;
}
.tab{
  width: 200px;
  height: 60px;
  flex-direction: row;
  align-items: center;
  line-height: 60px;
}
.index{
  width: 80px;
  display: inline-block;
  line-height: 60px;
  cursor: pointer;
}
.download{
  width: 80px;
  display: inline-block;
  line-height: 60px;
  cursor: pointer;
}
.select{
  color: #0099FF;
}
.no-select{
  color: #222222;
}
.footer{
  width: 100%;
  height: auto;
  background-color: #363951;
  // position: fixed;
  // bottom: 0;
  // left: 0;
}
.footer-content{
  width: 60%;
  height: 100%;
  margin: 0 auto;
  color: #9A9BA7;
  font-size: 14px;
  padding: 40px 0px 20px 0px;
}
.line {
  height: 1px;
  width: 100%;
  background-color: #4F5266;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue